import {Component, Input} from '@angular/core';

import {IDynamicComponent} from '../../models/dynamic-component-loader/IDynamicComponent.model';

@Component({
  template: `
    <div class="bank-account-number-component">
    <span class="item" *ngFor="let item of dialogStructure">
        {{item.label}}:
        <span class="data"> <b>{{item.value}}</b>
        <button mat-icon-button matSuffix [cdkCopyToClipboard]="item.value"
                #tooltip="matTooltip"
                matTooltip="Copy {{item.label}} to clipboard"
                matTooltipPosition="above">
          <mat-icon class="notranslate icon">content_copy</mat-icon>
        </button>
        </span>
      </span>
    </div>
  `,
  styles: [
    `
    .bank-account-number-component {
      display: flex;
      flex-direction:column;
      gap:24px;

      ::ng-deep .mat-mdc-icon-button {
        padding: 0;
      }
    }

    .item {
      display: flex;
      flex-direction:column;

      .data {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .icon {
        color: #3D47E2;
        font-size: 16px;
        width:16px;
        height: 16px;
        display: flex;
        align-items: center;
      }

      button {
        line-height: 22px;
        width: min-content;
        height: min-content;
      }
    }


    `
  ]
})
export class BankAccountNumberComponent implements IDynamicComponent {
  @Input() data: any;
  dialogStructure: any;
  ngOnInit() {
    this.dialogStructure = [
      {
        label: 'Account holder name',
        value: this.data.name,
      },
      {
        label: 'Bank name',
        value: this.data.bankName
      },
      {
        label: 'Account number',
        value: this.data.accountNumber
      },
      ...(this.data.achRoutingNumber === this.data.wireRoutingNumber ? [
        {
          label: 'Routing No (ACH, Wire)',
          value: this.data.achRoutingNumber
        }
      ] : [{label: 'Routing No (ACH)', value: this.data.achRoutingNumber || '-'}, {label: 'Routing No (Wire)', value: this.data.wireRoutingNumber || '-'}]),
      {
        label: 'Account holder address',
        value: this.data.address || '-'
      }
    ]
  }

}
